import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';
import { reportPublicError } from '@/observability/publicTelemetry';

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    void info;
    reportPublicError(error, 'render');
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <main className="fatal-state" role="alert">
          <p className="eyebrow">FnB Customer</p>
          <h1>Không thể mở trang</h1>
          <p>Vui lòng tải lại trang hoặc quét lại mã QR.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Tải lại
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
